<template>
  <section v-if="rfq && rfq.c_estimation && rfq.c_estimation.insulation">
    <h1>The Mitrex System and Energy Savings</h1>
    
    <div class="columns flex--justify-center mt-4">
      <div class="column r-value__wrapper">
        <img 
          class="r-value__icon"
          alt="Upgraded Area" 
          src="https://camas.app/resources/static/images/images/image__ff452ceb3a4b118484ae2a8e31fe2e09.png"/>
        <div class="r-value__desc">
          Upgraded Area
        </div>
        <div>
          {{ rfq.c_estimation.insulation.area | commasep(0) }} SQFT
        </div>
      </div>

      <div class="column r-value__wrapper">
        <img
          class="r-value__icon"
          alt="Existing R-Value" 
          src="https://camas.app/resources/static/images/images/image__c530abf8572f91be602dac7084c51765.png"/>
        <div class="r-value__desc">
          Existing R-Value
        </div>
        <div>
          {{ rfq.c_estimation.insulation.curr }}
        </div>
      </div>

      <div class="column r-value__wrapper">
        <img
          class="r-value__icon"
          alt="Mitrex R-Value" 
          src="https://camas.app/resources/static/images/images/image__bf937a53dd9a5133d51c285846d00184.png"/>
        <div class="r-value__desc">
          Mitrex R-Value
        </div>
        <div>
          {{ rfq.c_estimation.insulation.newr }}
        </div>
      </div>
    </div>


    <div class="mb-5">
      If your current heating system is any of the below, you can find the 
      approximate savings over {{ rfq.c_estimation.insulation.years }} years.
    </div>

    <div class="columns flex--align-center">
      <div class="column r-value__wrapper">
        <img 
          class="r-value__icon"
          alt="Natural Gas" 
          src="https://camas.app/resources/static/images/images/image__8c930fb9bffe0e04e7bc22d1b308388a.png"/>
        <div class="r-value__desc">
          Natural Gas
        </div>
        <div>
          {{ rfq.c_estimation.insulation.ng_saving_nyear | currency(0) }}
        </div>
      </div>

      <div class="column r-value__wrapper">
        <img
          class="r-value__icon"
          alt="Fuel Oil" 
          src="https://camas.app/resources/static/images/images/image__5ce316556642f64e509d2151138591a2.png"/>
        <div class="r-value__desc">
          Fuel Oil
        </div>
        <div>
          {{ rfq.c_estimation.insulation.oil_saving_nyear | currency(0) }}
        </div>
      </div>
      
      <div class="column r-value__wrapper">
        <img
          class="r-value__icon"
          alt="Propane" 
          src="https://camas.app/resources/static/images/images/image__3abb9dff464d1ebd657d5b5c7526a687.png"/>
        <div class="r-value__desc">
          Propane
        </div>
        <div>
          {{ rfq.c_estimation.insulation.prop_saving_nyear | currency(0) }}
        </div>
      </div>

      <div class="column r-value__wrapper">
        <img
          class="r-value__icon"
          alt="Electricity" 
          src="https://camas.app/resources/static/images/images/image__35ee1634dc6b12872e6ee17e1c6966f7.png"/>
        <div class="r-value__desc">
          Electricity
        </div>
        <div>
          {{ rfq.c_estimation.insulation.elec_saving_nyear | currency(0) }}
        </div>
      </div>
      
    </div>

    <div class="mb-5" v-if="desc" v-html="desc">
    </div>
    
  </section>
</template>

<script>
export default {
  props: {
    desc: {
      type: [String, Number],
      default: null
    },
    rfq: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/flexbox.scss';

.r-value__icon {
  height: 80px;
  width: auto;
  margin: 5px 5px;
}

.r-value__desc {
  color: #0E4E74;
  font-weight: bold;
}

.r-value__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0E4E74;
}
</style>